var $dad545c909cfec2d$exports = {};
// index.js
(()=>{
    "use strict";
    const $ = (sel, el = document)=>el.querySelector(sel);
    const $$ = (sel, el = document)=>Array.from(el.querySelectorAll(sel));
    /* ==========================================================
     THEME (global entre páginas)
     - chave: hub_theme
     - aplica em index e quem-somos
  ========================================================== */ const THEME_KEY = "hub_theme";
    const btnTheme = $("#btnTheme");
    const getPreferredTheme = ()=>{
        const saved = localStorage.getItem(THEME_KEY);
        if (saved === "dark" || saved === "light") return saved;
        const systemDark = window.matchMedia?.("(prefers-color-scheme: dark)")?.matches;
        return systemDark ? "dark" : "light";
    };
    const syncThemeButton = (theme)=>{
        if (!btnTheme) return;
        const isDark = theme === "dark";
        btnTheme.setAttribute("aria-pressed", String(isDark));
        const ico = btnTheme.querySelector(".theme-ico");
        const text = btnTheme.querySelector(".theme-text");
        if (ico) ico.textContent = isDark ? "\uD83C\uDF19" : "\u2600\uFE0F";
        if (text) text.textContent = isDark ? "Dark" : "Light";
    };
    const applyTheme = (theme, persist = true)=>{
        // light é padrão (sem atributo), dark usa data-theme="dark"
        if (theme === "dark") document.documentElement.setAttribute("data-theme", "dark");
        else document.documentElement.removeAttribute("data-theme");
        if (persist) localStorage.setItem(THEME_KEY, theme);
        syncThemeButton(theme);
    };
    // aplica no load
    applyTheme(getPreferredTheme(), true);
    // toggle manual
    btnTheme?.addEventListener("click", ()=>{
        const current = document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";
        applyTheme(current === "dark" ? "light" : "dark", true);
    }, {
        passive: true
    });
    // sincroniza em múltiplas abas
    window.addEventListener("storage", (e)=>{
        if (e.key === THEME_KEY && (e.newValue === "dark" || e.newValue === "light")) applyTheme(e.newValue, false);
    });
    /* ==========================================================
     SEU JS ORIGINAL (sem alterações funcionais)
  ========================================================== */ // Cursor glow (RAF + CSS vars)
    const glow = $("#cursorGlow");
    const motionOK = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const coarsePointer = window.matchMedia("(pointer: coarse)").matches;
    if (motionOK && !coarsePointer) {
        let raf = null, x = 0, y = 0;
        window.addEventListener("mousemove", (e)=>{
            x = e.clientX;
            y = e.clientY;
            if (!raf) raf = requestAnimationFrame(()=>{
                document.documentElement.style.setProperty("--mx", x);
                document.documentElement.style.setProperty("--my", y);
                glow.style.opacity = "1";
                raf = null;
            });
        }, {
            passive: true
        });
        window.addEventListener("mouseleave", ()=>glow.style.opacity = "0", {
            passive: true
        });
    }
    // Reveal on scroll
    const revealEls = $$("[data-reveal]");
    const io = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("in");
                io.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.12
    });
    revealEls.forEach((el)=>io.observe(el));
    // Smooth scroll (apenas âncoras internas)
    $$('a[href^="#"]').forEach((a)=>{
        a.addEventListener("click", (e)=>{
            const id = a.getAttribute("href");
            const target = document.querySelector(id);
            if (!target) return;
            e.preventDefault();
            target.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        });
    });
    // Counters
    const counters = $$(".kcount");
    let counted = false;
    function animateCounters(list) {
        list.forEach((el)=>{
            const end = Number(el.dataset.count || "0");
            const duration = 900 + Math.random() * 450;
            const t0 = performance.now();
            function tick(t) {
                const p = Math.min((t - t0) / duration, 1);
                const eased = 1 - Math.pow(1 - p, 3);
                el.textContent = String(Math.round(end * eased));
                if (p < 1) requestAnimationFrame(tick);
            }
            requestAnimationFrame(tick);
        });
    }
    const dash = document.querySelector("#dados");
    if (dash) new IntersectionObserver((entries, obs)=>{
        if (!counted && entries.some((e)=>e.isIntersecting)) {
            counted = true;
            animateCounters(counters);
            // barra do painel
            const pct = Number($("#metaPct")?.textContent || "0");
            $("#metaBar") && ($("#metaBar").style.width = Math.max(0, Math.min(pct, 100)) + "%");
            obs.disconnect();
        }
    }, {
        threshold: 0.25
    }).observe(dash);
    // CTA scroll
    $("#btnScrollPilares")?.addEventListener("click", ()=>{
        $("#pilares")?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    });
    $("#btnScrollDados")?.addEventListener("click", ()=>{
        $("#dados")?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    });
    // Login buttons
    const goLogin = ()=>window.location.href = "login.html";
    $("#btnEntrar")?.addEventListener("click", goLogin);
    $("#btnEntrarNav")?.addEventListener("click", goLogin);
    $("#btnCadastrar")?.addEventListener("click", goLogin);
    // Footer year
    $("#year").textContent = new Date().getFullYear();
    // Mobile menu toggle
    const menuBtn = $("#menuBtn");
    const mainNav = $("#mainNav");
    function isMobileNav() {
        return window.matchMedia("(max-width: 860px)").matches;
    }
    function closeMenu() {
        if (!mainNav || !menuBtn) return;
        mainNav.classList.remove("open");
        menuBtn.setAttribute("aria-expanded", "false");
    }
    function openMenu() {
        if (!mainNav || !menuBtn) return;
        mainNav.classList.add("open");
        menuBtn.setAttribute("aria-expanded", "true");
    }
    function toggleMenu() {
        if (!mainNav || !menuBtn) return;
        mainNav.classList.contains("open") ? closeMenu() : openMenu();
    }
    menuBtn?.addEventListener("click", (e)=>{
        e.stopPropagation();
        toggleMenu();
    });
    // Fecha ao clicar em qualquer link
    mainNav?.querySelectorAll("a").forEach((a)=>{
        a.addEventListener("click", ()=>{
            if (isMobileNav()) closeMenu();
        });
    });
    // Fecha ao clicar fora
    document.addEventListener("click", (e)=>{
        if (!isMobileNav()) return;
        if (!mainNav?.classList.contains("open")) return;
        const clickedInsideNav = mainNav.contains(e.target);
        const clickedMenuBtn = menuBtn?.contains(e.target);
        if (!clickedInsideNav && !clickedMenuBtn) closeMenu();
    });
    // Fecha no ESC
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") closeMenu();
    });
    // Fecha ao redimensionar para desktop
    window.addEventListener("resize", ()=>{
        if (!isMobileNav()) closeMenu();
    }, {
        passive: true
    });
})();


//# sourceMappingURL=hub-resiliencia-em-rede.f1fd4494.js.map
